import { render, staticRenderFns } from "./ImportCsvModal.vue?vue&type=template&id=767b4dd7"
import script from "./ImportCsvModal.vue?vue&type=script&lang=ts"
export * from "./ImportCsvModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('767b4dd7')) {
      api.createRecord('767b4dd7', component.options)
    } else {
      api.reload('767b4dd7', component.options)
    }
    module.hot.accept("./ImportCsvModal.vue?vue&type=template&id=767b4dd7", function () {
      api.rerender('767b4dd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ImportCsvModal.vue"
export default component.exports